import { FC } from 'react';

import Stepper from 'components/Stepper';
import { StepOptions } from 'components/Stepper/types';

import SaveClientAlert from '../components/SaveClientAlert';
import ClientForm from './ClientForm';

interface IndividualFormProps {
  shouldAutoFill: boolean;
}

const IndividualForm: FC<IndividualFormProps> = ({ shouldAutoFill }) => {
  const steps: StepOptions[] = [
    {
      key: 'client-individual-form',
      render: (props) => (
        <ClientForm {...props} shouldAutoFill={shouldAutoFill} />
      ),
    },
    {
      key: 'client-save-changes-alert',
      render: () => <SaveClientAlert />,
    },
  ];

  return <Stepper steps={steps} />;
};

export default IndividualForm;
